import { FaLongArrowAltUp as LongArrowUp } from 'react-icons/fa';

export default LongArrowUp;
